







































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import UpdateFaqArticleRequest from '@/models/FaqArticles/UpdateFaqArticleRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import AgencyUserStatus from '@/models/AgencyUsers/AgencyUserStatus';
import FaqArticleDto from '@/models/FaqArticles/FaqArticleDto';

@Component({
    name: 'FaqArticleEdit'
})
export default class extends GiganautVueDialog {

  public entity = new UpdateFaqArticleRequest
  public editorKey = 0;
  public editorReady = false;

  @Prop({required: true})
  public faqArticle: FaqArticleDto;

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.editorReady = false;
      this.entity = new UpdateFaqArticleRequest();
      const existingVal = JSON.parse(JSON.stringify(this.faqArticle));
      this.entity.title = existingVal.title;
      this.entity.body = existingVal.body;
      this.entity.updatedAt = existingVal.updatedAt;
      this.editorKey++;
      this.$nextTick(() => {
        this.editorReady = true;
      });
    } else {
      this.editorReady = false;
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    await AgencySettingsModule.editFaqArticle(this.entity)
    this.dialog = false;
  }
}
